<template>
    <div class="single-profile" v-if="profile">
        <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        <EmptyProfile v-if="profile.status === 'empty'" :segment="profile.slug"/>
        <PendingProfile v-else-if="
                    profile.status === 'judgment_pending'
                    || profile.status === 'disapproved'
                "/>
        <Profile v-else :id="profile.data.id"></Profile>
    </div>
</template>

<script>
  import EmptyProfile from "../components/EmptyProfile";
  import PendingProfile from "../components/PendingProfile";
  import Profile from "../components/Profile";
  import VBreadcrumbs from 'vuetify/es5/components/VBreadcrumbs/VBreadcrumbs'
  export default {
    name: "SingleProfile",
    components: {
      Profile,
      PendingProfile,
      EmptyProfile,
      VBreadcrumbs
    },
    data: () => ({
       searched_slug: ''
     }),
    computed: {
      profile: function () {
        return this.$store.state.segments && Array.isArray(this.$store.state.segments)
          ? this.$store.state.segments.find(el => this.searched_slug === el['slug'])
          : null
      },
      breadcrumbs: function () {
        return this.profile
            ? [
            {
              text: this.$t('Profiles'),
              exact: true,
              to: '/profiles'
            },
            {
              text: this.profile.name,
              disabled: true
            }
          ]
            : []
      }
    },
    beforeMount () {
      if (!this.$route.params.slug) {
        this.$router.replace('/profiles')
      } else {
        this.searched_slug = this.$route.params.slug
      }
    }
  }
</script>

<style scoped>

</style>
